module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "swiper-container",
    attrs: {
      "id": "mySwiper"
    }
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, _vm._l((_vm.bannerList), function(banner, index) {
    return _c('div', {
      key: index,
      staticClass: "swiper-slide"
    }, [_c('img', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": banner.img,
        "mode": "aspectFill"
      }
    })])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next"
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.showPdf,
      "title": "",
      "width": "800px",
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.showPdf = $event
      }
    }
  }, [_c('pdf', {
    attrs: {
      "src": _vm.pdfSrc
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "feature-area section-padding2",
    staticStyle: {
      "padding-top": "40px"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "section-top text-center"
  }, [_c('h2', [_vm._v("MENU")]), _vm._v(" "), _c('p', [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": require("../../static/assets/images/013.jpg"),
      "mode": "aspectFill"
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": require("../../static/assets/images/014.jpg"),
      "mode": "aspectFill"
    }
  })])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70b29d41"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/BlogDetails.vue
// module id = 239
// module chunks = 1